import {AppLocalStorage} from "@services/utils";

export default function () {
  return {
    user: JSON.parse(AppLocalStorage.getItem('taxiAuth.user')),
    token: AppLocalStorage.getItem('taxiAuth.token'),
    expire_time: Number(AppLocalStorage.getItem('taxiAuth.expire_time'))
  }
}
